import { createAction, props } from '@ngrx/store';
import { PenaltyOverride, QuoteOverrides } from 'src/app/core/models/cancellation-overrides.model';
import { CommissionRefund, QuoteRequest } from 'src/app/core/models/itinerary.model';
import { ContractError } from 'src/app/core/models/models';
import {
  CancellationConfirm,
  CancellationQuote,
  FeedbackModelML,
  PaymentChannel,
  PenaltyFareBasis,
  PenaltyFareBasisMachineLearning
} from 'src/app/core/models/cancellation.model';

export const LoadCancellationSuccess = createAction(
  '[Itinerary/Cancellation Page] Load cancellation  success',
  props<{ cancellationQuote: CancellationQuote }>()
);

export const loadPenaltiesSuccess = createAction(
  '[Itinerary/Cancellation Page] Load Penalties success',
  props<{ penaltyFareBasis: PenaltyFareBasis[] }>()
);

export const loadPenaltiesMLSuccess = createAction(
  '[Itinerary/Cancellation Page] Load Penalties ML success',
  props<{ penaltyMLFareBasis: PenaltyFareBasisMachineLearning }>()
);

export const loadingPenaltiesRequest = createAction(
  '[Itinerary/Cancellation Page] Load penalgies request'
);

export const goToStep1 = createAction('[Cancellation Page] Go to step 1');
export const goToStep2 = createAction('[Cancellation Page] Go to step 2');
export const CloseModal = createAction('[Cancellation Page] Close Modal Error');

export const ChoosePaymentChannel = createAction(
  '[Cancellation Page] Load payment channel',
  props<{ paymentChannel: PaymentChannel }>()
);

export const LoadPaymentChannelSuccess = createAction(
  '[Cancellation Page] Load payment channel success',
  props<{ paymentChannelsByCountry: PaymentChannel[] }>()
);

export const LoadPaymentChannelFail = createAction(
  '[Cancellation Page] Load payment channel fail',
  props<{ error: ContractError }>()
);

export const CancelPnrRequest = createAction(
  '[Cancellation Page] Cancel pnr request',
  props<{ cancellationQuoteRequest: QuoteRequest }>()
);

export const CancelPnrSuccess = createAction(
  '[Cancellation Page] Cancel pnr request success',
  props<{ pnrCancellationQuote: CancellationConfirm }>()
);

export const CancelPnrFail = createAction(
  '[Cancellation Page] Cancel pnr request fail',
  props<{ cancellationError: ContractError }>()
);

export const OverrideQuoteRequest = createAction(
  '[Cancellation Page] Override quote request',
  props<{ quoteOverrides: QuoteOverrides }>()
);

export const OverrideQuoteSuccess = createAction(
  '[Cancellation Page] Override quote success',
  props<{ cancellationQuote: CancellationQuote }>()
);

export const OverrideQuoteFail = createAction(
  '[Cancellation Page] Override quote fail',
  props<{ error: ContractError }>()
);

export const ToggleIsGdsRefundSwitch = createAction(
  '[Cancellation Page] Toggle GDS refund switch',
  props<{ activeGdsRefundSwitch: boolean }>()
);

export const SplitPnrRequest = createAction(
  '[Cancellation Page] Split pnr request',
  props<{ quoteRequest: QuoteRequest }>()
);

export const SplitPnrSuccess = createAction(
  '[Cancellation Page] Split pnr request success',
  props<{ cancellationQuote: CancellationQuote }>()
);

export const SplitPnrFail = createAction(
  '[Cancellation Page] Split pnr request fail',
  props<{ cancellationError: ContractError }>()
);

export const AddCancellationCode = createAction(
  '[Cancellation Page] Add Cancellation Code',
  props<{ cancellationCode: string }>()
);

export const FailRefund = createAction('[Cancellation Page] Refund Fail');

export const StoreQuoteRequest = createAction(
  '[Cancellation Page] Store Quote Request',
  props<{ quoteRequest: QuoteRequest }>()
);

export const CreatePenaltiesOverride = createAction(
  '[Cancellation Page] Create Penalties Override',
  props<{ penaltiesOverride: PenaltyOverride[] }>()
);

export const PenaltiesModal = createAction(
  '[Cancellation Page] Penlaty Modal',
  props<{ penaltyQoute: PenaltyFareBasis }>()
);

export const UpdateQuoteOverrides = createAction(
  '[Cancellation Page] Update Quote Overrides',
  props<{ quoteOverrides: QuoteOverrides }>()
);

export const AddCommissions = createAction(
  '[Cancellation Page] Add commissions refund to the quote request',
  props<{ commissions: CommissionRefund[] }>()
);

export const errorLoadMachineLearningParameter = createAction(
  '[Cancellation Page] Error Load Machine Learning'
);

export const sendFeedbackML = createAction(
  '[Cancellation Page] Machine Learning Feedback',
  props<{ feedback: FeedbackModelML }>()
);

export const sendFeedbackMLSuccess = createAction(
  '[Cancellation Page] Machine Learning Feedback success',
  props<{ result: string }>()
);

export const SetReceivedFrom = createAction(
  '[Cancellation Page] Set Received From',
  props<{ receivedFrom: string }>()
);

export const RemoveReceivedFrom = createAction('[Cancellation Page] Remove Received From');
